export default __webpack_public_path__ + "media/color/prl-7b4c9ab2.svg";